import { render, staticRenderFns } from "./transferPassengerList.vue?vue&type=template&id=3edd6930&scoped=true&"
import script from "./transferPassengerList.vue?vue&type=script&lang=ts&"
export * from "./transferPassengerList.vue?vue&type=script&lang=ts&"
import style1 from "./transferPassengerList.vue?vue&type=style&index=1&id=3edd6930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd6930",
  null
  
)

export default component.exports